import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'About Us', path: '/about' },
    { name: 'Contact Us', path: '/contact' },
    { name: 'Maps', path: '/maps' }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_fee065bf-0317-4432-aaa9-7ab2b5910186/artifacts/366zs7sx_Bhagat-Prop-Built-WHITE-BG%20%281%29.png" 
              alt="Bhagat Prop Built" 
              className="h-14 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-10">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-base font-medium transition-colors hover:text-[#B8944A] whitespace-nowrap ${
                  isActive(item.path) ? 'text-[#B8944A]' : 'text-gray-700'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Phone Numbers */}
          <div className="hidden lg:flex items-center gap-4">
            <a href="tel:+919999505420" className="flex items-center gap-2 text-gray-900 font-semibold text-base hover:text-[#B8944A] transition-colors">
              <div className="w-10 h-10 bg-[#B8944A] rounded-full flex items-center justify-center">
                <Phone className="text-white" size={18} />
              </div>
              <span>9999505420</span>
            </a>
            <span className="text-gray-400">|</span>
            <a href="tel:+917838486828" className="flex items-center gap-2 text-gray-900 font-semibold text-base hover:text-[#B8944A] transition-colors">
              <div className="w-10 h-10 bg-[#B8944A] rounded-full flex items-center justify-center">
                <Phone className="text-white" size={18} />
              </div>
              <span>7838486828</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-gray-700 hover:text-[#B8944A]" 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`text-base font-medium transition-colors hover:text-[#B8944A] ${
                    isActive(item.path) ? 'text-[#B8944A]' : 'text-gray-700'
                  }`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <div className="flex flex-col gap-3 pt-2 border-t border-gray-200 mt-2">
                <a href="tel:+919999505420" className="flex items-center gap-2 text-gray-900 font-semibold">
                  <Phone className="text-[#B8944A]" size={20} />
                  <span>9999505420</span>
                </a>
                <a href="tel:+917838486828" className="flex items-center gap-2 text-gray-900 font-semibold">
                  <Phone className="text-[#B8944A]" size={20} />
                  <span>7838486828</span>
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;